export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看单据',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ sendSampleStatus }) => !['N'].includes(sendSampleStatus),
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ sendSampleStatus }) => !['N'].includes(sendSampleStatus),
  },
  {
    text: that.$l('menu_text_shipment') || '发货确认',
    icon: 'el-icon-s-check',
    menuType: 'shipment',
    divided: true,
    allow: 'C',
    disabled: ({ sendSampleStatus }) => !['N'].includes(sendSampleStatus),
  },
  {
    text: that.$l('menu_text_receive') || '签收确认',
    icon: 'el-icon-box',
    menuType: 'receive',
    allow: 'R',
    disabled: ({ sendSampleStatus }) => !['Y'].includes(sendSampleStatus),
  },
]
